<template>
    <div>
        <canvas ref="pieChart"></canvas>
    </div>
</template>

<script>
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
    props: {
        title: {
            required: false,
            type: String || null,
            default: null
        },
        labels: {
            required: true,
            type: Array
        },
        labels_background_color: {
            required: false,
            type: Array || null,
            default: null
        },
        dataset: {
            required: true,
            type: Array
        },
        legend_position: {
            required: false,
            type: String || null,
            default: null
        },
        legend_font_size: {
            default: 13,
            required: false,
        },
        height: {
            required: false,
            type: Number,
            default: 380
        }
    },
    mounted() {
        this.renderChart()
        this.setHeight()
    },
    watch: {
        dataset(newV, oldV) {
            if (newV == oldV) return
            this.updateChart()
        },
        labels(newV, oldV) {
            if (newV == oldV) return
            this.updateChart()
        }
    },
    methods: {
        updateChart() {
            this._pieChart.destroy();
            this.renderChart()
            this.setHeight()
        },
        renderChart() {
            this._pieChart = new Chart(
                this.$refs.pieChart,
                {
                    type: 'doughnut',
                    plugins: [ChartDataLabels],
                    options: {
                        // aspectRatio: 1,
                        maintainAspectRatio: false,
                        animation: true,
                        responsive: true,
                        plugins: {
                            legend: {
                                display: true,
                                position: this.legend_position,
                                labels: {
                                    usePointStyle: true,
                                    pointStyle: 'rectRounded',
                                    font: {
                                        weight: 'bold',
                                        size: this.legend_font_size,
                                    }
                                }
                            },
                            tooltip: {
                                enabled: true,
                                callbacks: {
                                    label: function (context) {
                                        return `${context.raw}-${context.label}`;
                                    }
                                }
                            },
                            title: {
                                display: this.title ? true : false,
                                text: this.title,
                                font: {
                                    size: 15,
                                    weight: 'bold'
                                }
                            },
                            datalabels: {
                                color: 'white',
                                display: function (context) {
                                    let val = context.dataset.data[context.dataIndex]
                                    let sum = context.dataset.data.reduce((accumulator, curValue) => {
                                        return accumulator + curValue;
                                    })
                                    let percent = (val/sum)*100
                                    if (percent > 5) {
                                        return true
                                    }

                                    return false
                                },
                                font: {
                                    size: 13,
                                    weight: 'bold'
                                },
                            }
                        },
                    },
                    data: {
                        labels: this.labels,
                        datasets: [
                            {
                                hoverOffset: 4,
                                data: this.dataset,
                                backgroundColor: this.labels_background_color ? this.labels_background_color : this.generateColors(this.dataset.length),
                                datalabels: {
                                    anchor: 'center',
                                    backgroundColor: null,
                                    borderWidth: 0
                                }
                            },
                        ]
                    }
                }
            );
        },
        generateColors(count) {

            let colors = [];
            for (let i = 0; i < count; i++) {
                const color = 'rgba(' + this.getRandomValue() + ', ' + this.getRandomValue() + ', ' + this.getRandomValue() + ', 0.8)';
                colors.push(color);
            }
            return colors;
        },
        // Function to generate a random color value (0-255)
        getRandomValue() {
            return Math.floor(Math.random() * 256);
        },
        setHeight() {
            const pieChart = this.$refs.pieChart
            const chartHeight = this.height ? this.height : 380;
            pieChart.style.height = `${chartHeight}px`;
        }
    }
}
</script>